// ファイル操作ユーティリティ
import { AppConfig } from '../config.js';

export class FileUtils {
  static downloadBlob(blob: Blob, filename?: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `${AppConfig.file.defaultFilename}${AppConfig.file.extension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
} 